/** 总户 */
export const PUBLIC_TOTAL_TYPE = 10;

/** 现货组：一期后端可实现划拨 */
export const SPOT_GROUP_TYPES = [10, 11, 13, 15];

/** 合约组（含活动户 18）：一期仅展示，提交拦截 */
export const CONTRACT_GROUP_TYPES = [12, 14, 16, 17, 18];

export function isContractGroup(userType) {
  return CONTRACT_GROUP_TYPES.includes(Number(userType));
}

export function isSpotGroup(userType) {
  return SPOT_GROUP_TYPES.includes(Number(userType));
}

/** 单笔必须经总户：至少一侧为 10，且双方不同 */
export function isValidTransferPair(fromUserType, toUserType) {
  const from = Number(fromUserType);
  const to = Number(toUserType);
  if (!from || !to || from === to) return false;
  return from === PUBLIC_TOTAL_TYPE || to === PUBLIC_TOTAL_TYPE;
}

export const SIDE_OPTIONS = [
  { value: '', label: '不限' },
  { value: 'OUT', label: '作为转出方' },
  { value: 'IN', label: '作为转入方' },
];
